<mat-form-field floatLabel="always">
	<input matInput
				 type="password"
				 placeholder="{{ 'EXTERNALREGISTRATIONFORM.PASSWORD.PLACEHOLDER' | translate | uppercase }}"
				 required
				 name="password"
				 [(ngModel)]="password"
				 (change)="onChange()">
</mat-form-field>
<p *ngIf="password !== confirmationPassword && password !== '' && confirmationPassword !== ''" class="error-message">
	{{ 'EXTERNALREGISTRATIONFORM.PASSWORD.DONOTMATCH' | translate }}
</p>
<mat-form-field floatLabel="always">
	<input matInput
				 type="password"
				 placeholder="{{ 'EXTERNALREGISTRATIONFORM.CONFIRMATIONPASSWORD.PLACEHOLDER' | translate | uppercase}}"
				 required
				 name="confirmationPassword"
				 [(ngModel)]="confirmationPassword"
				 (change)="onChange()">
</mat-form-field>
